import type { Tab } from '~/components/TabsNavigator';

import { cva } from 'class-variance-authority';

export { default as CondoModal } from './Modal.vue';

export interface CondoModalProps {
	tab: Tab;
}

export const modalCarouselVariants = cva('flex flex-col', {
	variants: {
		variant: {
			default: 'h-[calc(100%-208px)]',
			zoomedImage: 'h-full md:h-[calc(100%-208px)]'
		}
	},
	defaultVariants: {
		variant: 'default'
	}
});
